import * as React from "react"
import PropTypes from "prop-types"
import { Fragment } from "react"
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHorizontalRule } from '@fortawesome/pro-regular-svg-icons'

const CtaBackground = ({title, intro, link, linkText, className, titleSize="h3", type }) => (
    <Row className={`${className} align-items-center cta`}>
      {type === 'Columns' ?
        <Fragment>
          <Col xs={12} md={8}>
            <h3 className={`${titleSize}`}>
              {title}    
            </h3>
            <p className={``}>
              {intro}    
            </p>
          </Col>
          <Col xs={12} md={4}>
            {
              link !== "" ? 
                <div className="text-center mt-1">
                  <a href={link} rel="noreferrer" className="btn btn-solid btn-loyall btn-dark" target="_blank">
                    {linkText}
                    <FontAwesomeIcon icon={faHorizontalRule} />
                  </a>
                </div>
              : null
            }
          </Col>
        </Fragment>
      :
        <Col xs={12}>
          <h3 className={`${titleSize} text-center`}>
            {title}    
          </h3>
          <p className={`text-center`}>
            {intro}    
          </p>
          {
            link !== "" ? 
              <div className="text-center mt-1">
                <a href={link} rel="noreferrer" className="btn btn-solid btn-loyall btn-dark" target="_blank">
                  {linkText}
                  <FontAwesomeIcon icon={faHorizontalRule} />
                </a>
              </div>
            : null
          }
        </Col>
      }
    </Row>
)

CtaBackground.propTypes = {
  title: PropTypes.string,
  intro: PropTypes.string,
  className: PropTypes.string,
  titleSize: PropTypes.string,
}

export default CtaBackground